import axios, { AxiosResponse } from 'axios';
import { FetchLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL, LOCAL_BASE_URL } from '../constants/apiEndpoints';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function shouldRetry(err: any): boolean {
  if (!axios.isAxiosError(err)) return false;
  const status = err.response?.status;
  // Retry only for transient failures.
  return status == null || status >= 500 || status === 429;
}
export const getAllLoungesApi = async ({
  sortType,
  LoungeId,
  currentPage,
  searchValue,
  shortByTime,
}: FetchLoungesType) => {
  const responseBody = (response: AxiosResponse) => response.data;

  let sorvalue = null;
  
  localStorage.setItem('pagename', 'Disneyland Talk');
  
  const token = localStorage.getItem('token');

  let sortByTime =
    shortByTime == 'true'
      ? `?page=${currentPage}&sortordefault=ww`
      : `?page=${currentPage}`;

  const user_id = localStorage.getItem('user_id');
  // remove endpoint
  const apiEndpoint = GET_BASE_URL + `/api/v1/home`;

  const getRequest = async (url: string) => {
    try {
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            Authorization: `bearer ${token}`,
          },
        })
        .then(responseBody);
    } catch (err) {
      if (!shouldRetry(err)) throw err;
      await sleep(650);
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            Authorization: `bearer ${token}`,
          },
        })
        .then(responseBody);
    }
  };

  if (searchValue != null) {
    const { data } = await getRequest(
      `${apiEndpoint}/search/post/${searchValue}${sortByTime}&user_id=${user_id}`
    );
    return data;
  } else {
    const { data } = await getRequest(`${apiEndpoint}${sortByTime}&user_id=${user_id}`);

    return data;
  }
};
